import React from "react";
import { Link } from "react-router-dom";

import SearchBox from "../../../../components/SearchBox";

import "./styles.css";

export default function HomeBreadcrumb({ type }) {
  return (
    <div
      className="col breadcrumbHome"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <Link to="/">
        <h1 className="acesso">
          Acesso <br /> <strong>{type}</strong>
        </h1>
      </Link>

      <div className="homeInfo">
        <Link
          className="infoButton"
          to={`/${type.toLowerCase()}/conteudo/saiba_identificar_se_um_profissional_e_registrado_no_crefito2_4876`}
        >
          Saiba identificar se um profissional é registrado no Crefito-2
        </Link>
        <Link
          className="infoButton"
          to={`/${type.toLowerCase()}/conteudo/parcelamento_de_dividas_6416`}
        >
          Parcelamento de dívidas
        </Link>
      </div>

      <SearchBox />
    </div>
  );
}
